/**
 * Spacing Utilities - Standardized spacing scale
 * Use these utilities instead of hardcoded spacing values
 */

export const spacing = {
  // Page-level spacing
  page: {
    container: 'max-w-7xl mx-auto',
    padding: 'px-6 py-8',
    full: 'max-w-7xl mx-auto px-6 py-8',
  },
  
  // Section spacing
  section: {
    gap: 'space-y-6',
    padding: 'p-6',
    margin: 'mb-6',
  },
  
  // Card spacing
  card: {
    padding: 'p-6',
    gap: 'space-y-4',
    header: 'px-6 py-4',
    body: 'px-6 py-4',
    footer: 'px-6 py-4',
  },
  
  // Button spacing
  button: {
    default: 'px-4 py-2',
    small: 'px-3 py-1.5',
    large: 'px-6 py-3',
  },
  
  // Form spacing
  form: {
    group: 'space-y-4',
    label: 'mb-2',
    input: 'px-3 py-2',
    help: 'mt-1',
  },
  
  // List spacing
  list: {
    item: 'py-2',
    gap: 'space-y-1',
  },
} as const;

/**
 * Get spacing value from CSS variable
 */
export function getSpacing(size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl'): string {
  return `var(--space-${size})`;
}

/**
 * Get responsive spacing
 */
export function getResponsiveSpacing(): string {
  return 'var(--space-responsive)';
}

